import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useControlEventsSubscription } from '@/modules/agent/hooks/useControlEventsSubscription'
import EditorContent from './EditorContent'
import EditorHeader from './EditorHeader'
import { useControlStatus } from '../../hooks/useControlStatus'
import { useSessionSubscription } from '../../hooks/useSessionSubscription'
import { getAgentData } from '../../states'

const index = ({isRefine}:{isRefine:boolean}) => {
  const { id } = useParams<{ id: string }>();
  
  // Subscribe to control events for session tracking
  useControlStatus(id || '');
  useSessionSubscription(id || '');
  useControlEventsSubscription(id || '');

  // Get documentation name from session data
  const agentData = getAgentData(id || '');
  const documentationName = (agentData?.sessionData as any)?.policy_management?.documentation_name || 'Policy Document';
  const confidence = (agentData?.mainData as any)?.confidence;
  return (
    <div className="bg-[#fdf1f5] h-full flex flex-col  gap-2">
      {/* Header Component */}
      <div className="bg-white rounded-t-lg shadow-sm">
        <EditorHeader 
          title={documentationName} 
          confidence={confidence} 
        />
      </div>
      
      {/* Editor Component */}
      <div className="bg-white rounded-lg shadow-sm flex-grow flex flex-col overflow-hidden mt-2 ml-4 mr-4 mb-2">
        <EditorContent isRefine={isRefine} />
      </div>
    </div>
  )
}

export default index